import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";

import { environment } from "../../environments/environment";

@Injectable({ providedIn: "root" })
export class HousingService {
    constructor(private http: HttpClient) { }

    getApplications(studentRegistrationId: number) {
        return this.http.get<any>(`${environment.apiUrl}/PortalHousing/GetApplications?studentRegistrationId=${studentRegistrationId}`);
    }

    getApplication(applicationId: number) {
        return this.http.get<any>(`${environment.apiUrl}/PortalHousing/GetApplication?applicationId=${applicationId}`);
    }

    insertOrUpdateHousingApplicationPersonalDetails(saveModel: any) {
        return this.http.post(`${environment.apiUrl}/PortalHousing/InsertOrUpdateApplicationPersonalDetails`, saveModel);
    }

    insertOrUpdateHousingApplicationLifestyleDetails(saveModel: any) {
        return this.http.post(`${environment.apiUrl}/PortalHousing/InsertOrUpdateApplicationLifestylePreferences`, saveModel);
    }

    insertOrUpdateHousingApplicationBuildingsDetails(saveModel: any) {
        return this.http.post(`${environment.apiUrl}/PortalHousing/InsertOrUpdateApplicationBuildingPreferences`, saveModel);
    }

    submitApplication(saveModel: any) {
        return this.http.post(`${environment.apiUrl}/PortalHousing/SubmitApplication`, saveModel);
    }

    getStudentSpecialNeedsDetails(studentRegistrationId: number) {
        return this.http.get<any>(`${environment.apiUrl}/PortalHousing/GetStudentSpecialNeedsDetails?studentRegistrationId=${studentRegistrationId}`);
    }

    getBuildingOptions(studentRegistrationId: number, scholasticPeriodId?: number, housingProgramId?: number) {
        return this.http.get<any>(`${environment.apiUrl}/PortalHousing/GetBuildingOptions?studentRegistrationId=${studentRegistrationId}&scholasticPeriodId=${scholasticPeriodId}&housingProgramId=${housingProgramId}`);
    }

    getHousingApplications(currentHousingStudentApplicationScholasticPeriodIds: number[], schoolId: number, providerId?: number, funnelId?: number) {
        let params = new HttpParams().set("providerId", String(providerId)).set("funnelId", String(funnelId)).set("schoolId", String(schoolId));

        for (let i = 0; i < currentHousingStudentApplicationScholasticPeriodIds.length; i++) {
            params = params.append("currentHousingStudentApplicationScholasticPeriodIds", String(currentHousingStudentApplicationScholasticPeriodIds[i]));
        }

        return this.http.get(`${environment.apiUrl}/PortalHousing/GetHousingApplications`, { params: params });
    }

    roommateSearch(saveModel: any) {
        return this.http.post(`${environment.apiUrl}/PortalHousing/RoommateSearch`, saveModel);
    }

    getCurrentRoommates(studentId: number, housingStudentApplicationId: number) {
        return this.http.get<any>(`${environment.apiUrl}/PortalHousing/CurrentRoommates?studentId=${studentId}&housingStudentApplicationId=${housingStudentApplicationId}`);
    }

    insertOrUpdateRoommateData(saveModel : any) {
        return this.http.post(`${environment.apiUrl}/PortalHousing/InsertOrUpdateRoommateRequests`, saveModel);
    }

    insertArrivalInformation(saveModel: any) {
        return this.http.post(`${environment.apiUrl}/PortalHousing/InsertArrivalInformation`, saveModel);
    }

    getHousingArrivalInformation(housingStudentApplicationId: number) {
        return this.http.get<any>(`${environment.apiUrl}/PortalHousing/HousingArrivalInformation?housingStudentApplicationId=${housingStudentApplicationId}`);
    }

    getCheckoutCharges(currencyId: number) {
        return this.http.get<any>(`${environment.apiUrl}/PortalHousing/CheckoutCharges?currencyId=${currencyId}`);
    }

    insertCheckoutInformation(saveModel: any) {
        return this.http.post(`${environment.apiUrl}/PortalHousing/InsertCheckoutInformation`, saveModel);
    }

    getHousingPrograms(currentHousingStudentApplicationHousingProgramIds: number[], schoolId: number) {
        let params = new HttpParams().set("schoolId", String(schoolId));

        for (let i = 0; i < currentHousingStudentApplicationHousingProgramIds.length; i++) {
            params = params.append("currentHousingStudentApplicationHousingProgramIds", String(currentHousingStudentApplicationHousingProgramIds[i]));
        }

        return this.http.get(`${environment.apiUrl}/PortalHousing/GetHousingPrograms`, { params: params });
    }

    cancelHousingStudentApplication(saveModel: any) {
        return this.http.post(`${environment.apiUrl}/PortalHousing/CancelHousingStudentApplication`, saveModel);
    }
}